import { MapSourceType } from '../Components/Map/types';

export const M_TO_FT = 3.28084;
export const M_TO_KM = 0.001;
export const M_TO_MI = 0.000621371;

export const initialLatitude = -31.953512;
export const initialLongitude = 115.857048;
export const initialExtentInDegrees = 0.512;
export const initialZoomHeight = 11;
export const STANDARD_FIELD_HEIGHT = 56;

export const ACTIVE = 'active';
export const ALL_LAYERS = 'all-layers';
export const ALL_DEVICES = 'All Devices';
export const ALL_GEOFENCES = 'All Geofences';
export const ALL_GEOFENCE_TYPES = 'All Geofence Types';
export const ALL_GEOFENCE_ZONES = 'All Geofence Zones';
export const ALL_GROUPS = 'All Groups';
export const ASSET_LAYER = 'ASSET_LAYER';
export const PIN_LAYER = 'PIN_LAYER';
export const HEATMAP_CONENTRATION = 'HEATMAP_CONENTRATION';
export const HEATMAP_LAYER = 'HEATMAP_LAYER';
export const SCALABLE_ROTATABLE_LAYER = 'SCALABLE_ROTATABLE_LAYER';
export const ASSET_DATA = 'ASSET_DATA';
export const CLUSTER_LAYER = 'CLUSTER_LAYER';
export const CLUSTER_MAX_ZOOM = 13;
export const CLUSTER_DISTANCE = 200;
export const CLUSTER_FONT_FAMILY = '"Open Sans","Montserrat","Arial",sans-serif,bold;';
export const DEFAULT_BUFFER_METERS = 250;
export const EBT_DISPLAY_LIMIT = 5;
export const EVENT_DATA = 'EVENT_DATA';
export const FENCE_VIEWING_HEIGHT = 12;
export const FRESH = 'fresh';
export const FRESH_LAYER = 'fresh-layer';
export const IS_INVISIBLE = 'IS_INVISIBLE';
export const IS_VISIBLE = 'IS_VISIBLE';
export const IS_LOCATION_TRACE = 'IS_LOCATION_TRACE';
export const IS_LOCATION_TRACE_DOTTED = 'IS_LOCATION_TRACE_DOTTED';
export const GEOFENCE_LAYER = 'GEOFENCE_LAYER';
export const GEOFENCE_EVENT_LAYER = 'GEOFENCE_EVENT_LAYER';
export const HISTORICAL_GEOFENCE_EVENT_LAYER = 'HISTORICAL_GEOFENCE_EVENT_LAYER';
export const GEOMETRY_HAS_CHANGED = 'geometryHasChanged';
export const GOOGLE_FLAG_FOR_MAP_TYPE: Record<MapSourceType, string> = {
  'Road map': 'm',
  Satellite: 's',
  'Satellite & Roads': 'y',
  'Terrain & Roads': 'p',
  'Road without Building': 'r',
  'Light map': 'lm',
  Nearmap: 's',
};
export const LOCATION_TRACE = 'LOCATION_TRACE';
export const LOCATION_TRACE_LABEL = 'LOCATION_TRACE_LABEL';
export const LAST_SENSED_ISO8601 = 'LAST_SENSED_ISO8601';
export const LOCATION_HISTORY = 'LOCATION_HISTORY';
export const MAP_SOURCE_TYPES = [
  'Road map',
  'Satellite',
  'Satellite & Roads',
  'Terrain & Roads',
  'Road without Building',
  'Light map',
  'Nearmap',
] as const;
export const MAGNIFY = 'MAGNIFY';
export const MICROFENCE_LAYER = 'MICROFENCE_LAYER';
export const MICROFENCE_LAYER_ID = '__microfences__';
export const MICROFENCE_LAYER_LABEL = 'MicroFences';
export const BOUNDARY_RSSI_DEFAULT = -90;
export const TIMEOUT_SECONDS_DEFAULT = 15;
export const PIN_ELEMENT_SCALE = 0.07;
export const POINT = '__point__';
export const PER_PAGE_DEFAULT = 200;
export const SENSED_ASSETS = 'SENSED_ASSETS';
export const SENSED_EXITED_ASSETS_IDS = 'SENSED_EXITED_ASSETS';
export const STREET_ADDRESS_ZOOM_LEVEL = 21.5;
export const TRACKED_DEVICE = 'Tracked device';
export const TRACKING_BOUNDS = 'tracking_bounds';
export const UPDATED = 'updated';
export const UNKNOWN = 'Unknown';
export const UNKNOWN_LAYER = 'unknown-layer';
export const ZOOM_THRESHOLD = 21.5;
/** Max zoom when auto-fitting map bounds (heatmap, geofence extent, etc.). */
export const MAP_FIT_MAX_ZOOM = ZOOM_THRESHOLD - 3;
